<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<cx-active-facets *limitUp="DEVICE_SIZE.DESKTOP"></cx-active-facets>

@if ((facetList$ | async)?.facets; as facets) {
  <section
    class="inner {{ facets.length ? classContainer : '' }}"
    [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate"
    [cxFocus]="isDialog ? dialogFocusConfig : {}"
    [tabindex]="-1"
    (esc)="close($event)"
    (click)="block($event)"
    >
    <div class="list-header">
      <h4 class="h3">{{ 'productList.filterBy.label' | cxTranslate }}</h4>
      <button type="button" class="close d-flex" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
        <!-- <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon> -->
        <span class="material-symbols-outlined d-flex"> close </span>
      </button>
    </div>
    @if (facets.length) {
      <div class="conteiner-facets">
        <obsolete-product />
        @for (facet of facets; track facet) {
          <cx-facet
            #facetRef
            [facet]="facet"
            [class.expanded]="isExpanded(facet) | async"
            [class.collapsed]="isCollapsed(facet) | async"
            role="group"
          attr.aria-label="{{
            'productFacetNavigation.ariaLabelItemsAvailable' | cxTranslate: { name: facet.name, count: facet?.values?.length }
          }}"
          ></cx-facet>
        }
      </div>
    } @else {
      <p class="d-block d-lg-none no-facet text-center m-t-20">
        {{ 'facets.noContent' | cxTranslate }}
      </p>
    }
  </section>
}
